import { ApiResponse, fetcher } from './base-api';
import { StatisticEntity } from './types/statistic.type';

export const getLatestStatistic = async (): Promise<
  ApiResponse<StatisticEntity>
> => {
  return fetcher<StatisticEntity>('/statistics/latest');
};
